<template>
    <div class="message-tags py-2">
        <message-tag v-for="(tag) in tags(message)"
                     :key="tag.id"
                     v-bind:message="message"
                     v-bind:tag="tag"
                     @onTagClick="tagClick"/>
    </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex'
import api from "@/api/api";
import MessageTag from "@/components/panel/sidebar/event/MessageTag";
import {appBus} from "@/main";
import {ON_CONTEXT_CLOSE, ON_FORWARD_MESSAGE} from "@/events";
import stopaApi from "@/api/stopa";
import {isEmpty, find} from "lodash";

export default {
    name: 'message-tags-context-menu',
    components: {MessageTag},
    props: [
        'message',
        'conversation',
    ],
    data() {
        return {
            messageFormDialog: true,
        }
    },
    computed: {
        ...mapState({
            messageCategories: state => state.messages.categories,
        }),
        ...mapGetters('messages', [
            'tags',
        ]),
        ...mapGetters('events', {
            eventById: 'byId',
            eventByConversationId: 'byConversationId',
        }),
    },
    methods: {
        async tagClick(tag, action) {
            if (action === 1) {

                let close = true;
                const regex = /FWD_(\d+)/gm;
                const forwardTag = regex.exec(tag.code);
                if (!isEmpty(forwardTag)) {

                    const tagMessageCategoryId = forwardTag[1];
                    const event = this.eventById(this.message.eventId);
                    const messageCategory = find(this.messageCategories, item => item.categoryId === parseInt(tagMessageCategoryId));
                    const targetConversation = find(event.conversations, item => item.type === messageCategory.id);

                    appBus.$emit(ON_FORWARD_MESSAGE, this.message, targetConversation, tag);
                    appBus.$emit(ON_CONTEXT_CLOSE);
                    return;
                }

                // Send message to isv
                if (tag.code === 'ISV') {
                    this.sendToSystem(tag);
                    return;
                }

                // Confirm message
                if (tag.code === 'CONF') {
                    this.$emit('onProcessing', true);
                    await this.$store.dispatch('messages/confirm', this.message.id)
                    this.$emit('onProcessing', false);
                    return;
                }

                if (tag.code === 'DZIN_INPUT') {
                    navigator.clipboard.writeText(this.message.content).then(() => {
                        this.$noty.success("Text zkopírováno do paměti");
                    }).catch(error => {
                        this.$noty.error("Chyba při kopírování textu do paměti");
                        console.error("Failed to copy text to clipboard:", error);
                    });
                    const event = this.eventByConversationId(this.message.eventId);
                    window.open("https://dsd.tudc.cz/app/dzin/editace/edit.php?hid=" + event.code, '_blank');
                    close = false;
                }

                this.applyTag(tag, close);
            }
            if (action === 0) {
                this.removeTag(tag);
            }
        },
        applyTag(tag, close = true) {
            this.$emit('onProcessing', true);
            return api.post('/v2/messages/' + this.message.id + '/tag/' + tag.id)
                .then((response) => {
                    this.$store.dispatch("notifications/add", {type: 'success', message: 'Požadavek odeslán'}, {root: true});
                    this.$store.dispatch('messages/set', response);
                })
                .catch((error) => {
                    this.$store.dispatch("notifications/add", {type: 'error', message: error}, {root: true});
                })
                .finally(() => {
                    this.$emit('onProcessing', false, close);
                })
        },
        removeTag(tag) {
            this.$emit('onProcessing', true);
            return api.delete('/v2/messages/' + this.message.id + '/tag/' + tag.id)
                .then((response) => {
                    this.$store.dispatch("notifications/add", {type: 'success', message: 'Požadavek odeslán'}, {root: true});
                    this.$store.dispatch('messages/set', response);
                })
                .catch((error) => {
                    this.$store.dispatch("notifications/add", {type: 'error', message: error}, {root: true});
                })
                .finally(() => {
                    this.$emit('onProcessing', false);
                })
        },
        sendToSystem(tag) {
            this.sendingToSystem = true;

            let formData = new FormData();
            formData.append('id', this.message.id);
            formData.append('unit_id', this.$store.getters['bases/getUserBase'].uid);

            this.$emit('onProcessing', false);

            return stopaApi.post('/ktc/panel/sendMessage', formData)
                .then((response) => {
                    if (response.status === 1) {
                        this.$store.dispatch("notifications/add", {type: 'success', message: response.msg});
                        this.applyTag(tag)
                    } else {
                        this.$store.dispatch("notifications/add", {type: 'error', message: response.msg});
                    }
                })
                .catch((error) => {
                    this.$store.dispatch("notifications/add", {type: 'error', message: error});
                }).finally(() => {
                    this.$emit('onProcessing', false);
                });
        },
    },
}
</script>
